
// en.js
export default {
  home: {
    about: 'About Us',
    more:'More'
  }
}